import React from "react";
import {connect} from "react-redux";
import BsForm from "components/form/BsForm";
import ConfirmationModel from "components/model/ConfirmationModel";
import ClientUserInfoActions from "./ClientUserInfoActions";
import {deleteClientUser, fetchClientUserInfo} from "core/actions/client-user-actions";
import CLIENT_USER_INFO_FORM from "./client-user-info-form";

class ClientUserInfoTab extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      confirmationWindow: {
        open: false
      }
    };
    this.formRef = React.createRef();
    this.props.fetchClientUserInfo(this.props.match.params.userId);
  }

  onHandleDelete() {
    this.setState({
      ...this.state,
      confirmationWindow: {
        ...this.state.confirmationWindow,
        open: true
      }
    });
  }

  closeConfirmationModel() {
    this.setState({
      ...this.state,
      confirmationWindow: {
        ...this.state.confirmationWindow,
        open: false
      }
    });
  }

  deleteClientUser() {
    this.closeConfirmationModel();
    this.props.deleteClientUser(this.props.match.params.userId)
  }

  render() {
    if (this.props.currentUser) {
      const formConfig = {
        ...CLIENT_USER_INFO_FORM,
        title: {
          actions: <ClientUserInfoActions
            user={this.props.currentUser}
            onHandleDelete={this.onHandleDelete.bind(this)}/>,
          back: {
            url: '/global/users',
            history: this.props.history,
            location: this.props.location
          }
        }
      };

      return (
        <div className="bs-form-container">
          <ConfirmationModel
            open={this.state.confirmationWindow.open}
            message="user_info.delete_client_user_confirmation_message"
            handleClose={this.closeConfirmationModel.bind(this)}
            handleApply={this.deleteClientUser.bind(this)}
          />

          <BsForm
            config={formConfig}
            formData={this.props.currentUser}
            disabled={true}/>
        </div>
      );
    } else {
      return null;
    }
  }
}

const mapStateToProps = (state) => {
  return {
    currentUser: state.clientUser.currentUser
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    fetchClientUserInfo: (userId) => {
      dispatch(fetchClientUserInfo(userId));
    },
    deleteClientUser: (userId) => {
      dispatch(deleteClientUser(userId));
    }
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ClientUserInfoTab);
